var VariableValueLogicModel = /** @class */ (function () {
    function VariableValueLogicModel(valueType, operator, variableName, variableGroupName, constValue, dataSourceCode, variableVersion) {
        this.valueType = valueType;
        this.operator = operator;
        this.variableName = variableName;
        this.variableGroupName = variableGroupName;
        this.constValue = constValue;
        this.dataSourceCode = dataSourceCode;
        this.variableVersion = variableVersion;
    }
    return VariableValueLogicModel;
}());
export { VariableValueLogicModel };
